if (!customElements.get('origen-collection-banner')) {
  customElements.define('origen-collection-banner', class extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.handleViewport = () => {
        if (this.chooser) this.chooser.open = this.desktop.matches;
      };
      this.desktop.addEventListener('change', this.handleViewport);
      this.observer = new MutationObserver(() => this.enhanceShortcuts());
      if (!this.enhanceShortcuts()) {
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.desktop?.removeEventListener('change', this.handleViewport);
    }

    enhanceShortcuts() {
      const navigation = this.querySelector('.ob-collection-shortcuts');
      if (!navigation) return false;
      this.observer.disconnect();
      this.chooser = navigation.closest('.ob-collection-chooser');
      if (!this.chooser) {
        this.chooser = document.createElement('details');
        this.chooser.className = 'ob-collection-chooser';
        const summary = document.createElement('summary');
        summary.textContent = this.dataset.shortcutsLabel;
        navigation.before(this.chooser);
        this.chooser.append(summary, navigation);
      }
      this.handleViewport();
      return true;
    }
  });
}
